// extracted by mini-css-extract-plugin
export default {"defaultLogo":"InstitutionLogo_defaultLogo__jB7dF","logo":"InstitutionLogo_logo__-2gvf"};